import { useContext } from 'react';
import RootStoreContext from '../model/RootStoreContext';

export const useRootStore = () => {
  return useContext(RootStoreContext);
}
